<!-- Start of PROFILE container -->

<div class="container-fluid wrapper-page">
  <div class="page-head">
    <h4 class="mt-2 mb-2">PROFILES</h4>
  </div>
  <div class="row" *ngIf="organisation !== 'null'">
    <div class="col-lg-12 col-sm-12">
      <div class="row">
        <div class="col-lg-4 col-sm-4" *ngFor="let profile of role_based_profiles[role]">
          <div class="profile-box bg-white m-b-30">
            <div class="row d-flex m-t-20 m-b-10">
              <div class="col-4">
                <div class="text-center"><i class="fa" [ngClass]="profile.icon"></i></div>
              </div>
              <div class="col-8">
                <h5 class="m-0">{{profile.title}}</h5>
              </div>
              <div class="btn-mb-5 col-12 col-lg-12 col-sm-12 col-md-12 m-t-20 text-center" style="margin-top: 30px;">
                <a href="" [routerLink]="[profile.create_url]" class="btn btn-outline-primary radius m-r">Create
                  Profile</a>
                <a href="" [routerLink]="[profile.edit_url]" class="btn btn-outline-success radius m-r">Edit
                  Profile</a>
                <a href="" [routerLink]="[profile.delete_url]" class="btn btn-outline-danger radius m-r">Delete
                  Profile</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="!organisation || organisation === 'null'">
    <div class="col-lg-12 col-sm-12">
      <div class="card">
        <div class="card-body">
          <p class="text-danger font-size-17">
            Please complete the Registration Process first in order to create profiles for Physicain, Patient and
            Frontdesk person.
          </p>
          <p><a routerLink="/info-basic" class="text-primary">Click Here</a> to create your Organisation Profile.</p>
        </div>
      </div>

    </div>
  </div>
</div>